import moment from 'moment'

let settings = null

const load = async (environment, language, modal) => {
  const showDisturbanceMessage = true
  let loaded = await import(`./settings/${environment}`)
  loaded = { ...loaded[language], ...loaded.common }

  switch (language) {
    case 'se':
      loaded.currencySymbol = ':-'
      loaded.thousandDelimiter = ' '
      loaded.dateRegex = /^\d{4}-\d{2}-\d{2}$/
      await import('moment/locale/sv')
      moment.locale('sv')
      break
    case 'no':
      loaded.currencySymbol = ',-'
      loaded.thousandDelimiter = ' '
      loaded.dateRegex = /^\d{2}-\d{2}-\d{4}$/
      await import('moment/locale/nb')
      moment.locale('nb')
      break
    case 'dk':
      loaded.currencySymbol = ',-'
      loaded.thousandDelimiter = '.'
      loaded.dateRegex = /^\d{2}-\d{2}-\d{4}$/
      await import('moment/locale/da')
      moment.locale('da')
      break
    case 'fi':
      loaded.currencySymbol = 'e'
      loaded.thousandDelimiter = ' '
      loaded.dateRegex = /^\d{2}-\d{2}-\d{4}$/
      await import('moment/locale/fi')
      moment.locale('fi')
      break
    default:
      break;
  }

  settings = {
    ...loaded, language, modal, environment, showDisturbanceMessage
  }
}

export { settings as default, load }